import * as React from 'react';
import styles from './index.module.sass'
import simStyles from './simulations.module.sass'
import { ITEMS_COUNT_SKEW, SIMULATION_SELECT, LG, MD, SM } from '../../constants/commonContsnts';
import { CONTENT, LOAD_CONTENT, CIRCLE } from '../../constants/animationConstants';
import { isMobile } from 'is-mobile'
import './index.sass'
import { Truck, Simulation } from 'types/data'

interface SliderItem {
  image?: string,
  title: string,
  subTitle: string,
  item: Truck | Simulation,
  images?: string[]
}

interface ISliderProps {
  items: SliderItem[],
  onSelect: Function,
  loading: {
    progress: number,
    max: number
  },
  type: string,
  onBack?: Function,
  onOpen?: Function,
  onMount?: Function,
  startItem?: number,
}

const circleWidths = [
  {
    between: [Infinity, LG],
    width: 624 / 2
  },
  {
    between: [LG, MD],
    width: 424 / 2
  },
  {
    between: [MD, SM],
    width: 304 / 2
  },
  {
    between: [SM, -Infinity],
    width: 264 / 2
  },
]

const CIRCLE_RADIUS = 360

const Slider: React.FunctionComponent<ISliderProps> = ({ startItem = 0, items, onMount = () => {}, onSelect, loading, type, onBack=()=>{}, onOpen=()=>{}}) => {
  const [activeItem, setActiveItem] = React.useState(startItem)
  const [isMenuOpened, setMenuOpened] = React.useState(false)
  const [animationItems, setAnimationItems] = React.useState<any>(null)
  const [activeHoveredItem, setHoveredItem] = React.useState<number | null>(null)
  const [simMenuItems, setSimMenuItems] = React.useState<any>(null)
  const [controlsPosition, setControlsPosition] = React.useState<any>(0)
  const simMenu = React.useRef<HTMLDivElement>(null)
  const rootItem = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    if(simMenu.current) {
      setSimMenuItems(
        simMenu.current.querySelectorAll("[data-item='menuitem']")
      )
    }
  }, [simMenu])

  React.useEffect(() => {
    if(rootItem.current) {
      const circle = rootItem.current.querySelector('.asdcrlc')
      const mnbtn = rootItem.current.querySelector('.mnbtn')
      const ctrls = rootItem.current.querySelector('.ctrls')
      if(circle && mnbtn && ctrls) { 
        setTimeout(() => {
          //@ts-ignore
          setControlsPosition((mnbtn!.offsetLeft - circle.offsetWidth - circle.offsetLeft) / 2 - ctrls.offsetWidth / 2)
        }, 50);
      }
      
    }
  }, [rootItem, isMenuOpened])

  React.useEffect(() => {
    if(simMenu.current && simMenuItems) {
      simMenu.current.scrollTop = simMenuItems[0]!.offsetHeight * (activeItem! - 2)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeItem])
  
  const getItems = (type: string) => {
    return rootItem.current && rootItem ? 
    rootItem.current.querySelectorAll(`[data-type=${type}]`)
      :
      null
  }

  const circleWidth = circleWidths.find(({between}) => 
    window.innerWidth < between[0] && window.innerWidth > between[1]
  )!.width

  
  const STROKE_WIDTH = 5
  const SVG_CIRCLE_RADIUS = circleWidth + 7 - STROKE_WIDTH * 2
  
  const CIRCUMREFENCE = SVG_CIRCLE_RADIUS * 2 * Math.PI

  React.useEffect(() => {
    setAnimationItems({
      [CONTENT]: getItems(CONTENT),
      [LOAD_CONTENT]: getItems(LOAD_CONTENT),
      [CIRCLE]: getItems(CIRCLE)
    })
  }, [rootItem])

  React.useEffect(() => {
    if(animationItems) {
      onOpen(animationItems)
      onMount()
    } 
  }, [animationItems, onOpen, onMount])

  const isSumulation = type === SIMULATION_SELECT

  const toggleMenu = () => setMenuOpened(!isMenuOpened)

  const prevItemIndex = activeItem - 1 < 0 ? items.length - 1: activeItem - 1
  const nextItemIndex = activeItem + 1 === items.length ? 0 : activeItem + 1
  
  const goToNextItem = () => loading.progress > 1 ? null : setActiveItem(nextItemIndex)
  
  const toToPrevItem = () => loading.progress > 1 ? null : setActiveItem(prevItemIndex)

  const clearHoveredItem = () => setHoveredItem(null)
  const enterHoveredItem = (i: number) => () => setHoveredItem(i)
  
  const item = items[activeItem]

  const CIRCLE_WIDTH = CIRCLE_RADIUS / items.length
  const SKEW_OFFSET = 1
  const SKEW = ITEMS_COUNT_SKEW.reduce((acc, item, i) => 
  i > items.length - 1 ? acc : item + acc
  , 0) + SKEW_OFFSET

  return (
    <div className={`${styles.root} ${isSumulation ? styles.root_closed: ''}`} ref={rootItem}>
      <div data-type={LOAD_CONTENT} className={`${isMobile() && isSumulation ? '' : simStyles.logo}`}></div>
      <div className={styles.wrapper}>
        {
          isSumulation ? 
          <div data-type={CONTENT} className={simStyles.backBtn} onClick={() => onBack(animationItems)}>
            <div></div>
          </div>
          :
          null

        }
        <div data-type={CONTENT} className={`${isMenuOpened && isMobile() ? styles.arrow_hidden : ''} ${styles.arrow_left} ${styles.arrow}`} onClick={toToPrevItem}>
        </div>
        <div data-type={CIRCLE}  className={`${styles.circle} asdcrlc ${isSumulation ? styles.circle_closed : ''}`}>
          <div className={styles.inner}>
            <div className={`${styles.nav} ${type === SIMULATION_SELECT ? styles.nav_rotate : ''}`}>
              {
                items.map((_, i) => {
                  return (
                    <div 
                      className={`
                        ${styles.nav_el}
                        ${(((activeItem === items.length - 1 - i ) && activeHoveredItem === null) || (activeHoveredItem === items.length - 1 - i )) && styles.nav_el_active}
                      `}
                      data-type={CONTENT} 
                      style={{ transform: `rotate(${CIRCLE_RADIUS - (i * CIRCLE_WIDTH)}deg) skewX(${SKEW}deg)` }}
                      key={i}>
                      <div 
                        className={styles.nav_el_child} 
                        style={{transform: `skew(-${SKEW}deg) rotate(-65deg)`}}
                      >
                      </div>
                    </div>
                  );
                })
              }
              <div
                data-type={LOAD_CONTENT}
                className={styles.loader}
              >
                <svg
                  className={styles.loader_ring}>
                  <circle
                    strokeDasharray = {`${CIRCUMREFENCE} ${CIRCUMREFENCE}`}
                    style={{
                      strokeDashoffset: `${CIRCUMREFENCE - (loading.progress / loading.max) * CIRCUMREFENCE}`
                    }}
                    className="progress-ring__circle"
                    stroke="white"
                    strokeWidth={STROKE_WIDTH}
                    fill="transparent"
                    r={SVG_CIRCLE_RADIUS}
                    cx={circleWidth}
                    cy={circleWidth}/>
                </svg>

              </div>
            </div>
            {
              type === SIMULATION_SELECT ?
              <>
                <div data-type={CONTENT} className={`${simStyles.wrapper} beginSim-hover`}>
                  <div className={`${simStyles.beginSim} sim-header`}>
                        <div className={simStyles.beginSim_header}>
                          BEGIN
                        </div>
                        <div>
                          SIMULATION
                        </div>
                      </div>
                  {
                    items.map((data, i) => (
                      <div  
                        className={`${simStyles.simContent} ${i === activeItem ? simStyles.simContent_active : ''}`}
                        onClick={() => !isMenuOpened && !data.item.disabled && onSelect({content: data.item, animationItems})}
                        key={i}
                        >                        
                        <div className={`${simStyles.simContent_title} title-hovered`}>
                          {data.title}
                        </div>
                        <div className={`${simStyles.simContent_subTitle} subTitle-hovered`}>
                          {data.subTitle}  
                        </div>
                        <div className={`${data.item.id} simcontent_image ${data.item.isSeparated ? 'separated' : 'notseparated'} ${simStyles.simContent_image}`}>
                          {/* <img src={data.images![currentAnimationImageIndex]} alt={`${data.title}-truck`} /> */}
                          <div className={simStyles.animation}></div>
                        </div>
                      </div>
                    ))
                  }
                    <div ref={simMenu} className={`${simStyles.menu} ${isMenuOpened ? simStyles.menu_active : ''}`}>
                    {
                      items.map((data, i) => (
                        <div 
                        key={i}
                        data-item='menuitem'
                        onMouseEnter={enterHoveredItem(i)}
                        onMouseLeave={clearHoveredItem}
                        className={`${simStyles.menu_item} ${i === activeItem ? simStyles.menu_itemActive : ''}`}
                        onClick={() => !data.item.disabled && onSelect({content: data.item, animationItems})}
                        >
                          {data.title} 
                          <div className={simStyles.menu_subtitle}>
                            {data.subTitle}
                          </div>
                        </div>
                      ))
                    }
                  </div>
                </div>
                <div
                  className={`${styles.content} ${styles.loadContent} load-content`}
                  style={{filter: 'none', zIndex: 3}}
                  data-type={LOAD_CONTENT}
                >
                  {
                    items.map((data, i) => (
                      <div  
                        className={`${simStyles.simContent} ${i === activeItem ? simStyles.simContent_active : ''}`}
                        onClick={() => !isMenuOpened && onSelect({content: data.item, animationItems})}
                        key={i}
                        >                        
                        <div className={`${simStyles.simContent_title} title-hovered`}>
                          {data.title}
                        </div>
                        <div className={`${simStyles.simContent_subTitle} subTitle-hovered`}>
                          {data.subTitle}  
                        </div>
                        <div className={`${data.item.id} simcontent_image ${data.item.isSeparated ? 'separated' : 'notseparated'} ${simStyles.simContent_image}`}>
                          {/* <img src={data.images![currentAnimationImageIndex]} alt={`${data.title}-truck`} /> */}
                          <div className={simStyles.animation}></div>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </>
              :
              <>
                {
                  items.map((data, i) => (
                    <div
                      key={i}
                      className={`
                        ${styles.content}
                        ${loading.progress > 0 ? styles.nobg : ''}
                        slider-content 
                        ${i === activeItem ? styles.content_active : ''}
                      `}
                      data-notloading={loading.progress < 1}
                      onClick={() => !data.item.disabled && onSelect({content: data.item, animationItems})}
                    >
                      <div 
                        data-type={CONTENT} 
                        className={`${styles.content_title} car-type-${data.title}`}
                      >
                        <span className='hidden-text'>
                          {data.title}
                        </span>
                        <span className='shown-text'>
                          {data.title}
                        </span>
                      </div>
                      <div data-type={CONTENT}
                        className={`${styles.content_subtitle} car-type-${data.title}`}
                      >
                        <span className='hidden-text'>
                          {data.subTitle}
                        </span>
                        <span className='shown-text'>
                          {data.subTitle}
                        </span>


                      </div>
                      <div 
                        className={styles.content_image}
                        data-type={CONTENT}
                        >
                        <img src={data.image} alt={data.title}/>
                        <div className={styles.content_begin}>
                          {
                            !isMobile() ? 
                              <>
                                BEGIN SIMULATION
                              </>
                              :
                              <>
                                TAP TO 
                                <br/>
                                BEGIN SIMULATION
                              </>
                          }
                        </div>
                      </div>
                    </div>
                    )
                  )
                }
                  
                <div
                  className={`${styles.loadContent} load-content`}
                  data-type={LOAD_CONTENT}
                >
                  <div className={styles.loadContent_logo}></div>
                  <div className={`${styles.loadContent_name} name-car-type-${item.title}`}>
                    {item.title}
                  </div>
                  <div className={`${styles.loadContent_subname} subname-car-type-${item.title}`}>
                    {item.subTitle}
                  </div>
                  <div className={styles.loadContent_title}>
                    Truck simulator
                  </div>
                  <div className={styles.loadContent_subtitle}>
                    master your hydrovac
                  </div>
                  <div className={styles.content_image}>
                    <img src={item.image} alt={`${item.title}-truck`}/>
                    <div className={styles.content_begin}>
                      loading
                    </div>
                  </div>
                </div>
              </>
            }
          </div>
        </div>
        <div data-type={CONTENT} className={`${isMenuOpened && isMobile() ? styles.arrow_hidden : ''} ${styles.arrow_right} ${styles.arrow}`} onClick={goToNextItem}>
        </div>
        {
          isSumulation ? 
            <>
              <div style={{left: controlsPosition, position: 'relative'}} date-type={CONTENT} className={`${isMenuOpened ? simStyles.controls : simStyles.controls_hidden} ctrls`}>
                  <div date-type={CONTENT} className={`${simStyles.arrow} ${simStyles.arrow_top}`} onClick={toToPrevItem}></div>
                    {
                      items.map((_, i) => (
                        <div 
                          key={i}
                          className={`
                          ${simStyles.bullet} 
                          ${i === activeItem && simStyles.bullet_active}
                          `}
                        >
                        </div>
                      ))
                    }
                  <div date-type={CONTENT} className={`${simStyles.arrow} ${simStyles.arrow_bottom}`} onClick={goToNextItem}></div>
              </div>
              <div data-type={CONTENT} className={`${isMenuOpened ? simStyles.menuBtn_resting : ''} mnbtn ${simStyles.menuBtn}`} onClick={toggleMenu}>
                  <div></div>
                <div></div>
              </div>
            </>
          :
          null

        }
      </div>
    </div>
  );
};

export default Slider;
